import { FlowTemplate } from './flowTemplates';

export const caffeSempioneTemplates: FlowTemplate[] = [
  {
    id: 'caffe-benvenuto',
    name: 'Benvenuto Caffè Sempione',
    description: 'Messaggio di benvenuto personalizzato per i nuovi clienti',
    category: 'Caffè Sempione',
    icon: '☕',
    tags: ['benvenuto', 'caffè', 'nuovo cliente'],
    nodes: [
      {
        id: '1',
        type: 'trigger',
        position: { x: 250, y: 50 },
        data: {
          label: 'Nuovo Cliente',
          triggerType: 'message_received',
          config: {}
        }
      },
      {
        id: '2',
        type: 'action',
        position: { x: 250, y: 150 },
        data: {
          label: 'Messaggio Benvenuto',
          actionType: 'send_message',
          config: {
            message: `☕ Benvenuto da Caffè Sempione! 🇮🇹

Siamo una torrefazione italiana con oltre 20 anni di esperienza. Selezioniamo le migliori arabiche da Brasile e Colombia, miscelandole con robusta indiana di alta qualità.

📍 Le nostre caffetterie:
• POGLIANO: Via Sempione 58 - Tel. 02 39520228
• PERO: Via Sempione 121 - Tel. 02 39481349

🎯 I nostri servizi:
• Caffetteria con prodotti freschi
• Miscele pregiate per casa e bar
• Corsi barista professionali
• Assistenza macchine 7/7

Scrivi MENU per vedere le nostre offerte del giorno!`
          }
        }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2', animated: true }
    ]
  },
  {
    id: 'caffe-menu-giorno',
    name: 'Menu del Giorno',
    description: 'Invia automaticamente il menu con prezzi e offerte',
    category: 'Caffè Sempione',
    icon: '📋',
    tags: ['menu', 'prezzi', 'offerte'],
    nodes: [
      {
        id: '1',
        type: 'trigger',
        position: { x: 250, y: 50 },
        data: {
          label: 'Richiesta Menu',
          triggerType: 'keyword',
          config: {
            keyword: 'menu'
          }
        }
      },
      {
        id: '2',
        type: 'action',
        position: { x: 250, y: 150 },
        data: {
          label: 'Invia Menu Completo',
          actionType: 'send_media',
          config: {
            mediaUrl: 'menu-caffe-sempione.pdf',
            mediaCaption: `☕ MENU CAFFÈ SEMPIONE

🥐 COLAZIONE (fino alle 11:00)
• Cappuccino + Cornetto: €2,50
• Caffè Espresso: €1,20
• Caffè Macchiato: €1,40
• Spremuta fresca: €3,50
• Croissant vuoto: €1,30
• Croissant farcito: €1,50

🥪 PRANZO VELOCE (12:00-14:30)
• Panino del giorno: €5,50
• Toast classico: €4,00
• Insalatona mista: €7,00
• Piatto caldo del giorno: €8,50

🍰 DOLCI DELLA CASA
• Tiramisù: €4,00
• Cheesecake: €4,50
• Cannolo siciliano: €3,50
• Pasticceria mignon (al pezzo): €1,20

☕ LE NOSTRE MISCELE (al kg)
• Miscela Bar: €18,00
• Miscela Arabica 100%: €22,00
• Miscela Decaffeinato: €20,00
• Cialde/Capsule compatibili: prezzi in sede

📱 Scrivi ORDINA per ordinare in anticipo!`
          }
        }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2', animated: true }
    ]
  },
  {
    id: 'caffe-ordine-anticipato',
    name: 'Gestione Ordini Anticipati',
    description: 'Permette ai clienti di ordinare per il ritiro',
    category: 'Caffè Sempione',
    icon: '📱',
    tags: ['ordine', 'takeaway', 'ritiro'],
    nodes: [
      {
        id: '1',
        type: 'trigger',
        position: { x: 250, y: 50 },
        data: {
          label: 'Richiesta Ordine',
          triggerType: 'keyword',
          config: {
            keyword: 'ordina'
          }
        }
      },
      {
        id: '2',
        type: 'action',
        position: { x: 250, y: 150 },
        data: {
          label: 'Form Ordine',
          actionType: 'send_message',
          config: {
            message: `📝 ORDINE ANTICIPATO - Caffè Sempione

Per completare il tuo ordine, inviaci queste informazioni:

1️⃣ Cosa desideri ordinare
2️⃣ Orario di ritiro (almeno 15 min da ora)
3️⃣ Sede preferita:
   • POGLIANO (6:30-20:00)
   • PERO (6:00-19:30)
4️⃣ Nome per il ritiro

Esempio: "2 cappuccini, 2 cornetti alla crema, ore 8:30, Pogliano, Mario"

✅ Ti confermeremo l'ordine entro 5 minuti!`
          }
        }
      },
      {
        id: '3',
        type: 'condition',
        position: { x: 250, y: 250 },
        data: {
          label: 'Sede Pogliano?',
          conditionType: 'contains',
          config: {
            value: 'pogliano'
          }
        }
      },
      {
        id: '4',
        type: 'action',
        position: { x: 100, y: 350 },
        data: {
          label: 'Conferma Pogliano',
          actionType: 'send_message',
          config: {
            message: `✅ Ordine ricevuto per POGLIANO!

📍 Via Sempione 58
☎️ 02 39520228

Il tuo ordine sarà pronto all'orario indicato.
Totale da pagare: [da calcolare]

Ti invieremo un messaggio 5 minuti prima che sia pronto!

Grazie per aver scelto Caffè Sempione ☕`
          }
        }
      },
      {
        id: '5',
        type: 'action',
        position: { x: 400, y: 350 },
        data: {
          label: 'Conferma Pero',
          actionType: 'send_message',
          config: {
            message: `✅ Ordine ricevuto per PERO!

📍 Via Sempione 121  
☎️ 02 39481349

Il tuo ordine sarà pronto all'orario indicato.
Totale da pagare: [da calcolare]

Ti invieremo un messaggio 5 minuti prima che sia pronto!

Grazie per aver scelto Caffè Sempione ☕`
          }
        }
      },
      {
        id: '6',
        type: 'delay',
        position: { x: 250, y: 450 },
        data: {
          label: 'Attendi preparazione',
          delayType: 'fixed',
          config: {
            delayTime: 10,
            delayUnit: 'minutes'
          }
        }
      },
      {
        id: '7',
        type: 'action',
        position: { x: 250, y: 550 },
        data: {
          label: 'Notifica Pronto',
          actionType: 'send_message',
          config: {
            message: `🔔 Il tuo ordine è PRONTO!

Ti aspettiamo per il ritiro.
Ricorda di mostrare questo messaggio alla cassa.

A presto! ☕`
          }
        }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2', animated: true },
      { id: 'e2-3', source: '2', target: '3', animated: true },
      { id: 'e3-4', source: '3', target: '4', animated: true, sourceHandle: 'true' },
      { id: 'e3-5', source: '3', target: '5', animated: true, sourceHandle: 'false' },
      { id: 'e4-6', source: '4', target: '6', animated: true },
      { id: 'e5-6', source: '5', target: '6', animated: true },
      { id: 'e6-7', source: '6', target: '7', animated: true }
    ]
  },
  {
    id: 'caffe-fidelity',
    name: 'Programma Fedeltà',
    description: 'Gestione punti e premi per clienti abituali',
    category: 'Caffè Sempione',
    icon: '💳',
    tags: ['fedeltà', 'punti', 'premi'],
    nodes: [
      {
        id: '1',
        type: 'trigger',
        position: { x: 250, y: 50 },
        data: {
          label: 'Richiesta Punti',
          triggerType: 'keyword',
          config: {
            keyword: 'punti'
          }
        }
      },
      {
        id: '2',
        type: 'action',
        position: { x: 250, y: 150 },
        data: {
          label: 'Saldo Punti',
          actionType: 'send_message',
          config: {
            message: `🎯 CARTA FEDELTÀ CAFFÈ SEMPIONE

Il tuo saldo punti: 127 punti ⭐

📊 Riepilogo:
• 1 punto ogni €1 speso
• Caffè gratis ogni 10 consumazioni
• Sconto 10% ogni 100 punti

🎁 Premi disponibili:
• 50 punti → Cornetto omaggio
• 100 punti → Sconto 10% 
• 200 punti → Kg caffè -20%
• 500 punti → Colazione completa gratis

Continua ad accumulare punti con ogni acquisto!`
          }
        }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2', animated: true }
    ]
  },
  {
    id: 'caffe-corso-barista',
    name: 'Info Corsi Barista',
    description: 'Informazioni sui corsi professionali',
    category: 'Caffè Sempione',
    icon: '🎓',
    tags: ['corsi', 'formazione', 'barista'],
    nodes: [
      {
        id: '1',
        type: 'trigger',
        position: { x: 250, y: 50 },
        data: {
          label: 'Richiesta Corsi',
          triggerType: 'keyword',
          config: {
            keyword: 'corso'
          }
        }
      },
      {
        id: '2',
        type: 'action',
        position: { x: 250, y: 150 },
        data: {
          label: 'Info Corsi',
          actionType: 'send_message',
          config: {
            message: `🎓 ACADEMY CAFFÈ SEMPIONE

Diventa un barista professionista con i nostri corsi!

📚 CORSO BASE (8 ore)
• Storia e botanica del caffè
• Tecniche di estrazione
• Latte art base
• Certificato riconosciuto
💰 €150 + IVA

📚 CORSO AVANZATO (16 ore)
• Latte art avanzata
• Miscele e tostatura
• Gestione caffetteria
• Stage in caffetteria
💰 €350 + IVA

📚 CORSO PERSONALIZZATO
• Programma su misura
• Orari flessibili
• 1-to-1 con maestro barista
💰 Su preventivo

📅 Prossime date disponibili:
• 15-16 Gennaio - Corso Base
• 22-24 Gennaio - Corso Avanzato

✍️ Scrivi PRENOTA CORSO per iscriverti!`
          }
        }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2', animated: true }
    ]
  },
  {
    id: 'caffe-assistenza-macchine',
    name: 'Assistenza Macchine',
    description: 'Supporto tecnico per macchine da caffè',
    category: 'Caffè Sempione',
    icon: '🔧',
    tags: ['assistenza', 'macchine', 'tecnico'],
    nodes: [
      {
        id: '1',
        type: 'trigger',
        position: { x: 250, y: 50 },
        data: {
          label: 'Richiesta Assistenza',
          triggerType: 'keyword',
          config: {
            keyword: 'assistenza'
          }
        }
      },
      {
        id: '2',
        type: 'action',
        position: { x: 250, y: 150 },
        data: {
          label: 'Menu Assistenza',
          actionType: 'send_message',
          config: {
            message: `🔧 ASSISTENZA TECNICA H24 - Caffè Sempione

Siamo operativi 7 giorni su 7, 365 giorni l'anno!

Per quale problema hai bisogno di assistenza?

1️⃣ Macchina non eroga caffè
2️⃣ Perdita d'acqua
3️⃣ Macinacaffè bloccato
4️⃣ Problemi di pressione
5️⃣ Manutenzione programmata
6️⃣ Altro problema

🚨 URGENZE: Chiama direttamente
📞 Tecnico reperibile: 335 1234567

Rispondi con il numero del problema per ricevere assistenza immediata.`
          }
        }
      },
      {
        id: '3',
        type: 'condition',
        position: { x: 250, y: 250 },
        data: {
          label: 'Urgente?',
          conditionType: 'contains',
          config: {
            value: 'urgente'
          }
        }
      },
      {
        id: '4',
        type: 'action',
        position: { x: 100, y: 350 },
        data: {
          label: 'Intervento Urgente',
          actionType: 'send_message',
          config: {
            message: `🚨 INTERVENTO URGENTE ATTIVATO!

Un nostro tecnico ti contatterà entro 30 minuti.

Nel frattempo:
• Spegni la macchina
• Chiudi l'acqua se c'è perdita
• Tieni a portata modello e matricola

Il tecnico sta arrivando! ⚡`
          }
        }
      }
    ],
    edges: [
      { id: 'e1-2', source: '1', target: '2', animated: true },
      { id: 'e2-3', source: '2', target: '3', animated: true },
      { id: 'e3-4', source: '3', target: '4', animated: true, sourceHandle: 'true' }
    ]
  }
];
